<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <div>
        <el-button
          type="primary"
          plain
          @click="event().toAddOrEditClick()">新建管理员</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="idd"
        label="编号"/>
      <el-table-column
        prop="account"
        label="管理员账号"/>
      <el-table-column
        prop="name"
        label="姓名"/>
      <el-table-column
        prop="group_name"
        label="管理员身份"
        width="161"/>
      <el-table-column
        fixed="right"
        label="管理"
        width="330">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toAddOrEditClick(scope.row)">
            编 辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            class="mini-el-button"
            plain
            @click="event().onDelClick(scope.row.uuid)">
            删 除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>


    <!-- 添加规格 -->
    <el-dialog
      :title="adminTitle"
      width="540px"
      :visible.sync="adminDialog">
      <el-form
        :model="admin"
        label-position="left"
        :rules="rules2"
        ref="ruleForm2"
        label-width="140px"
        class="demo-ruleForm">
        <el-form-item
          label="管理员账号："
          prop="account">
          <el-input
            class="dk-input"
            v-model="admin.account"/>
        </el-form-item>
        <el-form-item
          label="管理员姓名："
          prop="name">
          <el-input
            class="dk-input"
            v-model="admin.name"/>
        </el-form-item>
        <el-form-item
          label="管理员密码："
          prop="password">
          <el-input
            type="password"
            class="dk-input"
            v-model="admin.password"/>
        </el-form-item>
        <el-form-item
          label="管理员身份："
          prop="group_uuid">
          <el-select
            v-model="admin.group_uuid"
            clearable
            placeholder="请选择">
            <el-option
              v-for="item in group"
              :key="item.uuid"
              :label="item.name"
              :value="item.uuid"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="adminDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureClick('ruleForm2')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  getAdminList, deleteAdmin, getAdminDetail, addAdmin, editAdmin, getGroupList,
} from '../../api/system'
import { imgDomain } from '../../configs/env'
import { setId } from '../../jslib/set-id'
import commoonFunction from '../../mixins/common'

export default {
  mixins: [commoonFunction],
  data() {
    return {
      imgDomain,
      body: {
        keyword: '',
        page_index: 1,
        page_size: 20,
      },
      total: 0,
      tableData: [
      ],
      group: [],
      adminDialog: false,
      adminTitle: '新增管理员',
      admin: {
        name: '',
        account: '',
        password: '',
        group_uuid: '',
      },
      adminClass: [
        {
          uuid: '1212',
          name: 'xxxx',
        },
        {
          uuid: '1212',
          name: 'xxxx',
        },
      ],
      rules2: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        group_uuid: [
          { required: true, message: '请选择管理员身份', trigger: 'blur' },
        ],
      },
    };
  },

  components: {
  },
  created() {
    this.network().getAdminList()
    this.network().getGroupList()
  },
  methods: {
    handleCurrentChange() {
      this.network().getAdminList()
    },
    event() {
      return {
        toNextListClick: (uuid) => {
          this.$router.push({ path: 'commodity-class-next-list', query: { parent_uuid: uuid } })
        },
        toAddOrEditClick: (row) => {
          if (row) {
            this.network().getAdminDetail(row.uuid)
            return
          }
          this.adminDialog = true
        },
        onSureClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // 调接口
              if (this.admin.uuid) {
                this.network().editAdmin()
                return
              }
              this.network().addAdmin()
            } else {
              console.log('error submit!!');
            }
          });
        },
        onDelClick: (uuid) => {
          this.isDel('确定删除管理员, 是否继续?', 'deleteAdmin', uuid)
        },
      }
    },
    network() {
      return {
        getAdminList: async () => {
          const { status, data } = await getAdminList(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.total = data.total
        },
        getGroupList: async () => {
          const { status, data } = await getGroupList(this.body)
          if (status !== 200) return
          this.group = data.data
        },
        getAdminDetail: async (uuid) => {
          const { status, data } = await getAdminDetail(uuid)
          if (status !== 200) return
          this.admin = data
          this.admin.uuid = uuid
          this.adminDialog = true
        },
        addAdmin: async () => {
          const { status } = await addAdmin(this.admin)
          if (status !== 200) return
          this.$notify({
            title: '新增成功',
            message: '新增管理员成功',
            type: 'success',
          });
          this.network().getAdminList()
          this.adminDialog = false
        },
        editAdmin: async () => {
          const { status } = await editAdmin(this.admin)
          if (status !== 200) return
          this.$notify({
            title: '编辑成功',
            message: '编辑管理员成功',
            type: 'success',
          });
          this.network().getAdminList()
          this.adminDialog = false
        },
        deleteAdmin: async (uuid) => {
          const { status } = await deleteAdmin(uuid)
          if (status !== 200) return
          this.network().getAdminList()
          this.$notify({
            title: '删除成功',
            message: '删除管理员成功',
            type: 'success',
          });
        },
      }
    },
    handler() {
      return {
        isDel: (uuid) => {
          this.$confirm('确定删除分类, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.network().delCategory(uuid)
              .then(() => {
                if (this.tableData.length === 1 && this.total > 10) {
                  this.body.page_index = this.body.page_index - 1
                }
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
        },
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/system/admin-list.vue